var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusInprogressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5ew1ik647a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 396",
    transform: "translate(6282 1708)",
    style: {
      fill: "#034db2"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542 -315)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 23",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(542 315)",
    style: {
      fill: "#5278f7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 3",
    transform: "translate(-5740 -1393)",
    style: {
      clipPath: "url(#5ew1ik647a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61572",
    d: "M13.558 12.308a1.25 1.25 0 1 1-1.25-1.25 1.25 1.25 0 0 1 1.25 1.25z",
    style: {
      fill: "#fff"
    },
    transform: "translate(6279.692 1705.692)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61573",
    d: "M17.884 12.308a1.25 1.25 0 1 1-1.25-1.25 1.25 1.25 0 0 1 1.25 1.25z",
    style: {
      fill: "#fff"
    },
    transform: "translate(6279.692 1705.692)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61574",
    d: "M9.231 12.308a1.25 1.25 0 1 1-1.25-1.25 1.25 1.25 0 0 1 1.25 1.25z",
    style: {
      fill: "#fff"
    },
    transform: "translate(6279.692 1705.692)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInprogressIcon);
export default __webpack_public_path__ + "static/media/Status-inprogress-Icon.31e5f2e6d5d4a6b997f90fed347c916a.svg";
export { ForwardRef as ReactComponent };